import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import arisLogo from "../../../Assets/images/aris-logo.svg";

/**
 * Aris-branded fallback shown when the corporate slug returns 404 or the
 * activation page is otherwise unavailable. Per the spec we don't leak
 * whether a slug "exists in non-active state" — so the message is generic.
 */
const UnavailablePage = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-[#f7f7f7] px-6 text-center">
    <Helmet>
      <title>Activation page not available — Aris</title>
      <meta name="robots" content="noindex" />
    </Helmet>
    <img src={arisLogo} alt="Aris" className="h-12 mb-8" />
    <h1 className="text-2xl md:text-3xl font-semibold text-[#222] mb-3">
      Activation page not available
    </h1>
    <p className="text-base text-[#555] max-w-md mb-6">
      This activation link is no longer active. If you think this is a mistake,
      please contact your organization's administrator.
    </p>
    <Link
      to="/login"
      className="inline-flex items-center gap-2 rounded-full bg-[#0d5eaf] px-6 py-3 text-white font-medium hover:opacity-95 transition"
    >
      Go to Aris
    </Link>
  </div>
);

export default UnavailablePage;
